(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("productResource", ["$resource", productResource]);
    function productResource($resource) {
        return $resource("/api/products/:slug/:view/:action/:value", { slug: "@slug", value: "@value" }, {
            getInfo: {
                method: "GET",
                params: { view: "info" }
            },
            getPricing: {
                method: "GET",
                params: { view: "pricing" }
            },
            saveInfo: {
                method: "POST",
                params: { view: "info" }
            },
            savePricing: {
                method: "POST",
                params: { view: "pricing" }
            },
            getCrossSell: {
                method: "GET",
                params: { view: "crosssell" }
            },
            deleteCrossSell: {
                method: "DELETE",
                params: {
                    view: "crosssell",
                    action: "delete"
                }
            },
            addCrossSell: {
                method: "POST",
                params: {
                    view: "crosssell",
                    action: "add"
                }
            }
        });
    }
}());
